import type { CopilotRunContext } from '@heidi/agents/contracts';
import { atom } from 'jotai';

/**
 * Map of Projects run (project) id → its copilot escalation context.
 *
 * Written by `CopilotIntentHost` (the one place that durably knows the ids —
 * the run's linked session is NOT echoed on the `ProjectDetail` response, and
 * the `note-push-verification` artifact carries no sessionId). Read by the
 * active-note publisher (toolbar liveness in a run view), the background
 * registration (redaction marker), and the executor attach (redaction values).
 *
 * Patient-safety: readers consult it only for the project they are acting on,
 * so a stale entry can never publish another patient's note off-route.
 */
export const copilotRunContextByProjectAtom = atom<Record<string, CopilotRunContext>>({});
